export default __webpack_public_path__ + "static/media/world_network.10ab55d9.jpg";